/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";

function getWindow(): any {
   return window;
}

@Injectable({
   providedIn: "root"
})
export class WindowRefService {
   public get nativeWindow(): any {
      return getWindow();
   }
}
